import React, { useState } from 'react';
import { TrendingUpIcon, UsersIcon, LinkIcon, SearchIcon } from 'lucide-react';
import { DirectoryApplicationModal } from './DirectoryApplicationModal';
export const GrowthSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const features = [{
    title: 'Creator Directory',
    description: 'Get discovered by new audiences through our creator directory.',
    icon: <UsersIcon className="w-6 h-6" data-id="element-268" />
  }, {
    title: 'Product Catalog',
    description: 'Showcase your product recommendations in a searchable catalog.',
    icon: <SearchIcon className="w-6 h-6" data-id="element-269" />
  }, {
    title: 'Backlink Generation',
    description: 'Increase your SEO with quality backlinks from your listings.',
    icon: <LinkIcon className="w-6 h-6" data-id="element-270" />
  }];
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return <section className="py-24 border-t border-gray-100 relative" id="growth" data-id="element-271">
      <div className="max-w-4xl mx-auto mb-12" data-id="element-272">
        <h2 className="font-serif text-4xl font-bold text-center mb-6" data-id="element-273">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-274">
            Growth
          </span>
        </h2>
        <p className="text-lg text-gray-700 text-center mb-12" data-id="element-275">
          Expand your reach with our creator directory and product catalog
          platform.
        </p>
      </div>
      <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden p-8" data-id="element-276">
        <div className="flex items-center mb-8" data-id="element-277">
          <div className="bg-purple-50 p-3 rounded-xl shadow-sm mr-4" data-id="element-278">
            <TrendingUpIcon className="w-8 h-8 text-purple-600" data-id="element-279" />
          </div>
          <h3 className="font-serif text-3xl font-bold" data-id="element-280">
            Creator Growth Platform
          </h3>
        </div>
        <div className="mb-10" data-id="element-281">
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-282">
            Our directory platform showcases your product recommendations,
            provides a space for consumers to learn more about you and follow
            your work, and generates valuable backlinks to boost your online
            presence.
          </p>
          <div className="bg-purple-50 p-6 rounded-lg border-l-4 border-purple-500" data-id="element-283">
            <h4 className="font-medium text-xl mb-2" data-id="element-284">Why it matters</h4>
            <p className="text-gray-700" data-id="element-285">
              Increase your discoverability, build your audience, and improve
              your SEO ranking - all while providing more value to your
              followers.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-286">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md border border-gray-200 transition-all hover:shadow-lg hover:-translate-y-1" data-id="element-287">
              <div className="bg-purple-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-288">
                <div className="text-purple-600" data-id="element-289">{feature.icon}</div>
              </div>
              <h4 className="font-medium text-lg mb-2" data-id="element-290">{feature.title}</h4>
              <p className="text-gray-600" data-id="element-291">{feature.description}</p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-292">
          <button onClick={openModal} className="px-8 py-4 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition-all hover:shadow-lg" data-id="element-293">
            Apply to Join the Directory
          </button>
        </div>
      </div>
      <DirectoryApplicationModal isOpen={isModalOpen} onClose={closeModal} data-id="element-294" />
    </section>;
};